module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-8-sm-188ca42df30723d71f76b76b1030057d.png";